import React, { useState, useEffect } from 'react';
import Hero from '../components/Hero';
import Mission from '../components/Mission';
import Services from '../components/Services';
import Contact from '../components/Contact';
import { Menu, X } from 'lucide-react';

const Home = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <div className="home-page">
      {/* Navigation */}
      <nav className={`main-nav ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-container">
          <div className="nav-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_unknown-branding/artifacts/6va2y0ua_UNKNOWN-blanco.png" 
              alt="UNKNOW" 
            />
          </div>
          
          {/* Desktop Navigation */}
          <div className="nav-links desktop-nav">
            <button onClick={() => scrollToSection('mission')} className="nav-link">
              About
            </button>
            <button onClick={() => scrollToSection('services')} className="nav-link">
              Services
            </button>
            <button onClick={() => scrollToSection('contact')} className="nav-link">
              Contact
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="mobile-menu-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="mobile-nav">
            <button onClick={() => scrollToSection('mission')} className="mobile-nav-link">
              About
            </button>
            <button onClick={() => scrollToSection('services')} className="mobile-nav-link">
              Services
            </button>
            <button onClick={() => scrollToSection('contact')} className="mobile-nav-link">
              Contact
            </button>
          </div>
        )}
      </nav>

      {/* Sections */}
      <Hero />
      <div id="mission">
        <Mission />
      </div>
      <div id="services">
        <Services />
      </div>
      <div id="contact">
        <Contact />
      </div>

      {/* Footer */}
      <footer className="main-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_unknown-branding/artifacts/6va2y0ua_UNKNOWN-blanco.png" 
                alt="UNKNOW"
                style={{ height: '32px', width: 'auto', marginBottom: '12px' }}
              />
              <p className="footer-tagline">Contemporary Branding Solutions</p>
            </div>
            <div className="footer-copy">
              <p>© {new Date().getFullYear()} UNKNOW. All rights reserved.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Home;
